/**
 * Privat message list component.
 *
 * @param string uuid of the current conversation.
 */
export default function (uuid) {
    return {
        uuid,
        loading: false,
        hasScrolled: false,
        scrolled: function (e) {
            this.hasScrolled =
                e.target.scrollHeight > e.target.scrollTop + e.target.clientHeight + 50;
        },
        scroll: function () {
            this.$refs.messageArea.scrollTop = this.$refs.messageArea.scrollHeight;
        },
        mounted: function () {
            this.$nextTick(() => {
                this.scroll();
            });

            window.livewire.hook('afterDomUpdate', (e) => {
                if (e.name != 'private-messages.private-messages-list') {
                    return;
                }

                if (!this.hasScrolled) {
                    this.scroll();
                }

                if (this.loading === true) {
                    this.loading = false;
                }
            });

            window.livewire.on('openConversation', (new_uuid) => {
                if (new_uuid !== this.uuid) {
                    this.loading = true;

                    this.$nextTick(() => {
                        this.scroll();
                    });
                }
            });

            window.addEventListener(
                'conversation-opened',
                () => {
                    this.loading = false;
                },
                false
            );

            this.$watch('loading', () => {
                this.$nextTick(() => {
                    this.scroll();
                });
            });
        },
    };
}
